import { CustomComponentProps } from "utils/types/generalTypes";
import PostPlaceload from "../Loaders/PostPlaceload";
import ListPlaceload from "../Loaders/ListPlaceload";

export type LayoutLoaderProps = CustomComponentProps & {
    hide: boolean;
};

const LayoutLoader = ({ hide }: LayoutLoaderProps) => {
    return (
        <div id="shadow-dom" className={`view-wrap ${hide && "is-hidden"}`}>
            <div className="columns">
                <div className="column is-8">
                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.compose-card-placeload></x-loaders.compose-card-placeload> */}

                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.post-placeload></x-loaders.post-placeload> */}
                    <PostPlaceload />

                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.post-placeload></x-loaders.post-placeload> */}
                    <PostPlaceload />

                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.post-placeload></x-loaders.post-placeload> */}
                    <PostPlaceload />

                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.post-placeload></x-loaders.post-placeload> */}
                    <PostPlaceload />
                </div>

                <div className="column is-4">
                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.stories-placeload></x-loaders.stories-placeload> */}
                    <ListPlaceload />

                    {/* <!-- Placeload element --> */}
                    {/* <X-loaders.mini-widget-placeload></X-loaders.mini-widget-placeload> */}
                    <ListPlaceload />

                    {/* <!-- Placeload element --> */}
                    {/* <x-loaders.list-placeload></x-loaders.list-placeload> */}
                </div>
            </div>
        </div>
    );
};

export default LayoutLoader;
